import {dataStaticApp} from 'src/environments/colombia/data-static';
import {dataStaticAppVzla} from 'src/environments/venezuela/data-static';
import {brazeConfig} from '../environments/colombia/braze-config';
import {firebaseConfig} from '../environments/colombia/firebase-config';
import {firebaseEnv} from '../environments/colombia/firebase.env';
import {generalEnv, profileConfig} from '../environments/colombia/general.env';
import {metaTags as metaTagsCol} from '../environments/colombia/meta-data';
import {redes} from '../environments/colombia/redes.env';
import {ssrTokens} from '../environments/colombia/ssr-tokens';
import {zendeskConfigCol} from '../environments/colombia/zendesk.config';
import {environment} from '../environments/environment';
import {brazeConfigVzla} from '../environments/venezuela/braze-config';
import {firebaseVzlaConfig} from '../environments/venezuela/firebase-config';
import {firebaseVzlaEnv} from '../environments/venezuela/firebase.env';
import {generalVzlaEnv, profileConfigVzla} from '../environments/venezuela/general.env';
import {metaTags as metaTagsVen} from '../environments/venezuela/meta-data';
import {redesVzla} from '../environments/venezuela/redes.env';
import {ssrTokens as ssrTokensVzla} from '../environments/venezuela/ssr-tokens';
import {zendeskConfigVen} from '../environments/venezuela/zendesk.config';
import {VERSIONS} from 'src/versions'

export enum CountryEnum {
  COLOMBIA = 'COL',
  VENEZUELA = 'VEN',
}

export interface DefaultAnonymousData {
  activeOrders: number,
  addresses: Array<{
    latitude: number
    longitude: number,
    closerStoreId: number,
    active: boolean,
    defaultAddress: boolean
  }>,
  city: string,
  isAnonymous: boolean,
  idCustomerWebSafe: string,
  idStoreGroup: number,
  latitude: number,
  longitude: number,
  shopingCartNumber: number,
  vip: boolean
}

interface CountryConfig {
  isPrimeActive: boolean;
  cartBilled: boolean;
  mixedPayment: boolean;
  activeHighDemand: boolean;
  paymentMethodCity: boolean;
  disableScanAndGo: boolean;
  getActiveCities: boolean;
  getAvailability: boolean;
  getService: boolean;
  selectAddressVnzla: boolean;
  canActivateVenGuard: boolean;
  isExpress: boolean;
  debounceTime: number;
  updateAddress: boolean;
  cleanAddress: boolean;
  prefixPhone: number;
  setContact: boolean;
  fbDataBase: string;
  paymentMethods: {id: string; description: string; icon?: string}[];
  pseUrlDatabase: string;
  pseStatus: boolean;
  deliveryTime: boolean;
  accountPush: boolean;
  deliveryTruck: boolean;
  deliveryAirplane: boolean;
  zendeskId: number;
  matrix: number;
  redirectEnvialoYa: string;
  envialoYa: boolean;
  addressId: number;
  inviteSection: string;
  home: any;
  buildDataCol: boolean;
  defCoordsLat: number;
  defCoordsLng: number;
  algolia: {
    id: string,
    key: string,
    index: string,
    items_seo: string,
    properties:string,
    propierties?: any,
    hostTopsort?: string,
    hostAlgolia?: string,
    indexSub?: string,
  };
  backend: any;
  countryName: string;
  indicator: CountryEnum;
  currency: string;
  cctld: string;
  documentTypes: {id: number; type: string; description: string}[];
  phoneCode: string[];
  countryCode: number;
  routeImg: string;
  mobileAppUrl: string;
  countries: {id: string; prefix: number; flagUrl: string}[];
  firebaseEnv: {usePublicVapidKey: string; messagingSenderId: string};
  firebaseConfig: {
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
  };
  generalEnv: {
    keyClient: number;
    source: string;
    coordinates: {lat: number; lon: number};
    deliveryTypes: any;
  };
  isColombia?: boolean;
  isVenezuela?: boolean;
  zendesk: {chat: any};
  ssrTokens?: any;
  version: {
    RFC: string;
    date?: string;
  };
  analytics: {
    gtmContainer: string;
    googleAdsConversionId: string;
  };
  defaultStoreId: number;
  metaData: any;
  redes?: any;
  defaultCity: string;
  defaultNameCity: string;
  braze?: any;
  freeDelivery: boolean;
  indexSeoHtml: string;
  downloadApp?: boolean;
  showAppBar: boolean;
  textSeoHome?: any;
  cartComponent?: {
    offerTextCart?: string;
    getSustitutes?: boolean;
    noStok?: boolean;
    validate: boolean;
    navigate: boolean;
    locationManager: boolean;
    inStock?: boolean;
    quantitySummary?: boolean;
  };
  urlDirection: string;
  urlDirectionIndcator: string;
  ordersComponent?: {
    loadMoreOrders?: boolean;
  };
  producDetailComponent?: {
    getAllServices?: boolean;
    activateGtmObservable?: boolean;
    imageList?: boolean;
    deliveryTime?: boolean;
    productPetal?: boolean;
    storeAvailability?: boolean;
    gtmValidate?: boolean;
  };
  datafonoComponent?: {
    fbDataBase?: string;
  };
  algoliaSearchComponent?: {
    getFIlterOption?: {
      department?: boolean;
      category?: boolean;
    };
  };
  billingSummaryComponent?: {
    firstOption?: boolean;
    hiddenOption?: boolean;
  };
  navbarFiltersCategoriesComponent?: {
    orderBySelect?: boolean;
    showFilters?: boolean;
  };
  filtersComponent?: {
    getQueryParam?: string;
  };
  footerComponent?: {
    categories?: {
      babyCareLink?: string;
    };
    paymentMethods?: {
      dataphone?: string;
    };
    otherLinks?: {
      indexNav7?: boolean;
      indexNav8?: boolean;
      indexNav9?: boolean;
      indexNav10?: boolean;
      indexNav11?: boolean;
      indexNav12?: boolean;
      indexNav13?: boolean;
    };
    showDownApp?: boolean;
  };
  loginForm?: {
    sendMessage?: boolean;
    loadScript?: boolean;
    validateHtml: boolean;
    placeholderEmail?: string;
    FormControlValidate?: boolean;
    valuesValidate?: boolean;
    countryCodeValidate?: boolean;
  };
  mapComponent?: any;
  menuButtomComponent?: {
    addItems?: boolean;
    offerWorld?: boolean;
  };
  deliveryTypeComponent?: {
    national?: boolean;
    envialoYa?: boolean;
    envialoYaText?: boolean;
  };
  categories: any;
  guardActivate: boolean;
  storeGroupAlgolia?: boolean;
  addressExpress?: boolean;
  customerQuery?: boolean;
  general?: any;
  navbar?: any;
  productCard?: any;
  productDetailImg?: any;
  productImg?: any;
  signUpForm?: any;
  currencySymbol?: any;
  metaTags?: any;
  creditCard?: any;
  singUpFormComponent?: any;
  validatePhoneFormComponent?: any;
  cancelOrderVM?: any;
  customerAccountVM: any;
  account?: any;
  addEditAddress?: any;
  bannersComponent?: any;
  cartProductComponent: any;
  helpButton?: any;
  phoneLength?: any;
  orderDetail?: any;
  addEditAddressCoponent?: any;
  patchValue: boolean;
  setMarker: boolean;
  selectOptions: boolean;
  validateCoordinates: boolean;
  dataStatic: any;
  allowIdStartsWithZero: boolean;
  p2c: any;
  bolivarDigital: boolean;
  christmas: boolean;
  vto: {
    domain: string
  }
  temporalStock: number,
  amplitudeConfig: {
    platform: string,
    library: string,
    version: string,
    startVersion: string,
    initialReferringDomain: string,
    initialReferrer: string,
    language: string,
  },
  defaultAnonymousData?: DefaultAnonymousData,
}

const colombia: CountryConfig = {
  isPrimeActive: true,
  isExpress: true,
  mixedPayment: false,
  cartBilled: false,
  activeHighDemand: false,
  paymentMethodCity: false,
  getActiveCities: false,
  getAvailability: false,
  getService: false,
  selectAddressVnzla: false,
  disableScanAndGo: false,
  canActivateVenGuard: false,
  debounceTime: 500,
  updateAddress: true,
  cleanAddress: true,
  prefixPhone: 57,
  setContact: true,
  fbDataBase: 'https://stunning-base-delivery-tracking.firebaseio.com/',
  paymentMethods: [
    {id: '1', description: 'Efectivo'},
    {id: '2', description: 'Datáfonos'},
    {id: '3', description: 'Tarjeta de crédito'},
    {id: '4', description: 'Pago en Tienda'},
    {id: '5', description: 'Seguros Bolivar'},
    {id: '6', description: 'PSE', icon: 'pse'},
  ],
  pseUrlDatabase: 'https://stunning-base-pse.firebaseio.com/',
  pseStatus: true,
  deliveryTime: true,
  accountPush: true,
  deliveryTruck: true,
  deliveryAirplane: true,
  zendeskId: 360001078271,
  matrix: 1,
  redirectEnvialoYa: '/',
  addressId: 8,
  envialoYa: true,
  inviteSection: 'ofertas',
  home: {
    homeSections: [
      {
        componentType: 'BANNER',
        list: [
          {
            urlBanner:
              'https://lh3.googleusercontent.com/NtIpBl318WkKbL-Ag7jqUX-U4eWuUDQAQa' +
              'XernRyzDtk4Vt1GiaThav3XXkGGY1w1RFD7NjR9H5fCo98yF1HRQvyuPM8snf7gBn0xFs7AFLWO0Q',
            redirectURL: 'https://www.farmatodo.com.co/mundoOfertas',
            id: '1',
            firstDescription: 'default2',
            orderingNumber: 2,
          },
          {
            urlBanner:
              'https://lh3.googleusercontent.com/d4G22McK-iUo7tAO8IAFW7vT8POC41LszGlh' +
              'zimNPY4sDMBq3tgOnEdveAvmap60kiCDM7Ac2WuQq5o3gkebtbQYp3jaaaX9Mls',
            redirectURL: 'https://www.farmatodo.com.co/mundoOfertas',
            id: '1',
            firstDescription: 'default',
            orderingNumber: 1,
          },
        ],
      },
      {
        componentType: 'HTML_LABEL',
        label: "<font color='#418fde'>Hola </font> Estas son las mejores ofertas",
      },
      {
        componentType: 'ITEM_LIST',
      },
      {
        componentType: 'THIN_BANNER',
        redirectURL: 'https://www.farmatodo.com.co/destacados/21643',
        urlBanner:
          'https://lh3.googleusercontent.com/EBR0D-3Zc7_GxHOb1QzA0oIB3Vb9PHfJIJu9' +
          'Jyzto2TN82tqji2HDD4x1JuQfxPYIOkcT--saOzFTpjBlbpS1xwj_NOCjzfZwXc',
      },
      {
        componentType: 'SQUARE_BANNER',
        list: [
          {
            urlBanner:
              'https://lh3.googleusercontent.com/ZwZE35dfEruJwI3LpoZekeHNc_-Oq57y4dazayQHzve' +
              'HSE2mCbsK23DXPa463YFXUA4Za_h0exQoAcUkteSzu_Pw_yXvz9Z9GiM',
            redirectURL: 'https://www.farmatodo.com.co/programate-y-ahorra/galeria',
          },
          {
            urlBanner:
              'https://lh3.googleusercontent.com/INtMGoW9LvCG1Ss7y7hbJJaZ' +
              'b4BndpA-q5gE5LEX35uAD7qoTkDLcSLEWRDkfxCwhyOFOJ8eLqjN7zb6pkv-PVSy3HeRJYsb1g',
            redirectURL: 'https://www.farmatodo.com.co/buscar?product=ensure',
          },
        ],
      },
      {
        componentType: 'THIN_BANNER',
        redirectURL: 'https://www.farmatodo.com.co/programate-y-ahorra/galeria',
        urlBanner:
          'https://lh3.googleusercontent.com/bCeCSgA_xsWGXlVrman2Oy_JnDTB5RrvB6ny' +
          'iVR1C0f83w78UL_-SlJtqZjiMMhJypaxz5_qNDw8GtxMq78axVXXnQpRgnD0LwA',
      },
      {
        componentType: 'HTML_LABEL',
        label: 'Destacados',
      },
    ],
    bannerFull: true,
    renderBottom: true,
    metaData: {
      title: 'Farmatodo Venezuela - Droguería Online Domicilio las 24 Horas',
    },
  },
  buildDataCol: true,
  defCoordsLat: 4.68234,
  defCoordsLng: -74.043835,
  algolia: environment.algoliaColombia,
  backend: environment.backendColombia,
  firebaseConfig,
  firebaseEnv,
  generalEnv,
  countryCode: 57,
  ...profileConfig,
  countryName: 'Colombia',
  indicator: CountryEnum.COLOMBIA,
  isColombia: true,
  zendesk: zendeskConfigCol,
  currency: 'COP',
  cctld: 'co',
  routeImg: 'svg/col-flag.svg',
  ssrTokens,
  version: {
    RFC: '',
    date: '',
  },
  analytics: {
    gtmContainer: 'GTM-K2QWH8B',
    googleAdsConversionId: 'AW-955172857',
  },

  defaultStoreId: 26,
  metaData: metaTagsCol,
  redes,
  allowIdStartsWithZero: false,
  defaultCity: 'BOG',
  defaultNameCity: 'Bogotá',
  braze: brazeConfig.production,
  freeDelivery: false,
  indexSeoHtml: 'items_seo',
  downloadApp: false,
  showAppBar: true,
  textSeoHome: {
    footer: `
  <div class=" col-12 col-md-3">
      <h1 class="title-seo-h1">Droguería Online: Domicilio las 24 Horas</h1>
      <br><p class="description-page">¡Hola, Bienvenido a Farmatodo! Si aún no conoces nuestro portafolio, te contamos que tenemos todo lo que necesitas en un solo lugar:</p>
      <br><p class="description-page">Encontrarás desde productos de <a class= "text-seo-link" href="https://www.farmatodo.com.co/categorias/salud-y-medicamentos/drogueria">Droguería y farmacia</a>, ya que <strong>somos especialistas en medicamentos y todos los productos relacionados con el cuidado de salud</strong>, hasta todos productos de despensa como tortillas, gaseosas y mucho más. Es decir, que puedes adquirir todo en un solo lugar y a un clic de distancia.</p>

    </div>

    <div class=" col-12 col-md-3">
      <h2 class="title-seo-h2">¿Cómo explorar nuestra página y categorías?</h2>
      <br><p class="description-page">Lo primero que debes hacer es familiarizarte con ella. En la parte superior hallarás diversas pestañas, las cuales se componen por <a class= "text-seo-link"href="https://www.farmatodo.com.co/categorias/salud-y-medicamentos">Salud y
      Medicamentos</a>, <a class= "text-seo-link"href="https://www.farmatodo.com.co/categorias/belleza">Belleza</a>, <a class= "text-seo-link"href="https://www.farmatodo.com.co/categorias/cuidado-del-bebe">Cuidado del Bebé</a>, <a class= "text-seo-link"href="https://www.farmatodo.com.co/categorias/cuidado-personal">Cuidado Personal</a>, <a class= "text-seo-link"href="https://www.farmatodo.com.co/categorias/alimentos-y-bebidas">Alimentos y Bebidas</a>, y todo lo relacionado con el <a class= "text-seo-link"href="https://www.farmatodo.com.co/categorias/hogar-mascotas-y-otros">hogar, mascotas, diversión, entre otros.</a></p>
      <br><p class="description-page">De allí, se desplegará un universo de opciones para guiarte y llevarte a los productos que estás buscando. Además, podrás encontrar muchos más servicios destacados como nuestro <strong>domicilio 24 horas, los 7 días de la semana</strong>, el mundo de  <a class= "text-seo-link"href="https://www.farmatodo.com.co/mundoOfertas">ofertas de productos en todas las categorías</a>, <strong> EnvíaloYa Venezuela y Servicios Médicos.</strong></p>
      <br><p class="description-page"><strong> ¡Déjate llevar y vive una experiencia única con Farmatodo!</strong></p>

    </div>
    <div class=" col-12 col-md-3">
      <h2 class="title-seo-h2">¡Dile adiós al dolor!</h2>
      <br><p class="description-page">No pares tus actividades diarias y alivia esos síntomas con <a class= "text-seo-link" href="https://www.farmatodo.com.co/categorias/salud-y-medicamentos/alivio-del-dolor"">medicamentos para el malestar general.</a> Sabemos que en ocasiones nuestro cuerpo presenta diferentes dolores generales debido a las constantes actividades físicas que realizamos y estas señales de incomodidad también se pueden presentar internamente en el cuerpo debido a una mala alimentación.</p>
      <br><p class="description-page">En Farmatodo podrás encontrar
      <a class= "text-seo-link" href="https://www.farmatodo.com.co/categorias/salud-y-medicamentos/alivio-del-dolor/dolor-abdominal-y-colico">pastillas para cólicos</a> y aliviar esos dolores naturales. Además,  podrás navegar y encontrar <a class= "text-seo-link"  href="https://www.farmatodo.com.co/categorias/salud-y-medicamentos/alivio-del-dolor/muscular-y-articular">cremas para dolores musculares y articulares.</a> Así lograrás continuar con tus labores diarias. ¡Navega, descubre, elige tu producto y recíbelo a
      domicilio en menos de 35 minutos!</p>
    </div>

    <div class=" col-12 col-md-3">
      <h2 class="title-seo-h2">¡Previene los síntomas de la gripa!</h2>
      <br><p class="description-page">Sabemos que en ocasiones nuestro cuerpo recibe pequeñas bacterias que se adquieren de los objetos
      que tocamos en las calles o simplemente cuando hablamos muy cerca a una persona que puede tener gripe. Este tipo de síntomas los
      podemos controlar con
      <a class= "text-seo-link" href="https://www.farmatodo.com.co/categorias/salud-y-medicamentos/tratamiento-de-la-gripa">pastillas buenas para la gripe</a>
       o <a class= "text-seo-link" href="https://www.farmatodo.com.co/categorias/salud-y-medicamentos/tratamiento-de-la-gripa/
      descongestionante">
      medicamentos antigripales</a>, así al siguiente día ya te sentirás mejor y tu energía estará al 100%.</p>
      <br><p class="description-page">Evita los síntomas de
      <a class= "text-seo-link" href="https://www.farmatodo.com.co/categorias/salud-y-medicamentos/tratamiento-de-la-gripa/resfriado-y-gripa">la gripe</a>
      con una buena limpieza de manos cada vez que llegues a casa o de visitar a algún familiar, recuerda que el lavado y la duración del
      mismo, es fundamental para evitar infecciones. Además, un buen
      <a class= "text-seo-link" href="https://www.farmatodo.com.co/categorias/salud-y-medicamentos/botiquin-y-primeros-auxilios/antisepticos">gel
      antibacterial</a> te podrá prevenir de contraer bacterias indeseadas.</p>
    </div>`,
  },
  mobileAppUrl: 'https://farmatodo.onelink.me/35y3/InstallHome',
  general: {
    legalCountryName: 'Colombia S.A.',
    offerText: 'ofertas',
    sag: {
      devices: {
        ios: false,
        android: false,
        browser: false,
      },
      urlSAG: 'https://stunning-base-scan-and-go.firebaseio.com/',
      disabledHome: true,
    },
    programAndSave: true,
    disableSas: false,
    cartProductAvailable: false,
  },
  urlDirection: 'farmatodo.com.co',
  urlDirectionIndcator: 'com.co',
  ordersComponent: {
    loadMoreOrders: true,
  },
  producDetailComponent: {
    getAllServices: true,
    activateGtmObservable: true,
    imageList: true,
    deliveryTime: true,
    productPetal: false,
    storeAvailability: false,
    gtmValidate: false,
  },
  datafonoComponent: {
    fbDataBase: 'https://stunning-base-scan-and-go.firebaseio.com/',
  },
  algoliaSearchComponent: {
    getFIlterOption: {
      department: true,
    },
  },
  billingSummaryComponent: {
    firstOption: true,
    hiddenOption: true,
  },
  navbarFiltersCategoriesComponent: {
    orderBySelect: true,
    showFilters: true,
  },
  filtersComponent: {
    getQueryParam: 'AND Departamentos:',
  },
  footerComponent: {
    categories: {
      babyCareLink: 'cuidado-del-bebe',
    },
    paymentMethods: {
      dataphone: 'Datáfono',
    },
    otherLinks: {
      indexNav7: true,
      indexNav8: true,
      indexNav9: true,
      indexNav10: true,
      indexNav11: true,
      indexNav12: true,
      indexNav13: true,
    },
    showDownApp: true,
  },
  loginForm: {
    sendMessage: true,
    loadScript: true,
    validateHtml: false,
    placeholderEmail: 'Correo electrónico o número celular',
    FormControlValidate: false,
    valuesValidate: false,
    countryCodeValidate: true,
  },
  mapComponent: {
    defaultLocate: [4.68234, -74.043835],
    defaultLocateOpt: false,
    defaultZoom: 15,
    locateValid: false,
  },
  menuButtomComponent: {
    addItems: true,
    offerWorld: true,
  },
  deliveryTypeComponent: {
    national: true,
    envialoYa: true,
    envialoYaText: true,
  },
  cartComponent: {
    offerTextCart: 'en oferta',
    getSustitutes: true,
    noStok: true,
    validate: true,
    navigate: true,
    locationManager: false,
    inStock: true,
    quantitySummary: false,
  },
  categories: {
    tutorials: true,
    order: null,
  },
  guardActivate: true,
  storeGroupAlgolia: true,
  addressExpress: true,
  customerQuery: true,
  navbar: {
    tracking: 'tracking',
    modalAddressOne: true,
    modalAddressTwo: false,
    routerHome: true,
  },
  productCard: {
    petals: false,
    showPrice: true,
    cardClassCountry: '',
    priceIvaNoIva: false,
  },
  productDetailImg: {
    imageSmall: true,
    offerDescription: true,
  },
  productImg: {
    multiImage: true,
    getLabelText: true,
  },
  signUpForm: {
    zeroValidator: true,
  },
  currencySymbol: '$',
  metaTags: {
    title: 'Farmacia y droguería online 24 horas a domicilio - Farmatodo',
    description:
      'Farmatodo, cadena de droguerías de autoservicio especializada en productos para la salud, belleza, cuidado personal y cuidado del bebé.',
  },

  creditCard: {
    validateTokenCvv: true,
  },
  singUpFormComponent: {
    phoneCodeOption: false,
    documentTypeOption: true,
    directSingUp: false,
    socialIcons: true,
    divider: true,
  },
  validatePhoneFormComponent: {
    validateWhitSms: true,
  },
  cancelOrderVM: {
    bdata: false,
  },
  customerAccountVM: {
    phoneCode: false,
  },
  account: {
    phoneCode: false,
    typeDocument: false,
    countryCode: true,
    cardHeight: false,
  },
  addEditAddress: {
    municipality: false,
    currentPosition: false,
    placeId: false,
  },
  bannersComponent: {
    bannerAvailable: false,
  },
  cartProductComponent: {
    available: true,
  },
  helpButton: {
    supportItem: false,
    hasSession: false,
    zopim: false,
  },
  phoneLength: 10,

  orderDetail: {
    paymentType1: 'Efectivo',
    paymentType2: 'Datafono',
    objReOrderValidate: true,
    mapValidate: false,
  },
  addEditAddressCoponent: {
    objMapValidateLatLng: false,
    editDataPlaceId: false,
    notSearch: false,
    editPreviousAddress: false,
    editCityGroups: false,
    addressRequired: false,
    autocompleteEmptyLatLng: false,
    selectMunicipalityUndefined: false,
    selectAddressValidateCoordinates: false,
  },
  patchValue: false,
  setMarker: false,
  selectOptions: false,
  validateCoordinates: false,
  dataStatic: dataStaticApp,
  p2c: false,
  bolivarDigital: false,
  christmas: false,
  vto: {
    domain: 'farmatodo.com.co',
  },
  temporalStock: 20,
  amplitudeConfig: {
    platform: 'web',
    library: 'amplitude-js/8.21.4',
    version: '6.3.9',
    startVersion: '6.3.3',
    initialReferringDomain: 'www.farmatodo.com.co',
    initialReferrer: 'https://www.farmatodo.com.co/',
    language: 'Spanish',
  },
  defaultAnonymousData: {
    activeOrders: 0,
    addresses: [
      {"latitude": 4.68197251,"longitude": -74.04383515,"closerStoreId": 0,"active": false,"defaultAddress": false}
    ],
    city: "Bogota",
    isAnonymous: true,
    idCustomerWebSafe: "ahZzfnN0dW5uaW5nLWJhc2UtMTY0NDAyci4LEgRVc2VyIiQxYzg0OGYxMC03ZWVmLTQyNzItOTM0MS1kYTkxYTQ2MjcwYjcM",
    idStoreGroup: 26,
    latitude: 4.68197251,
    longitude: -74.04383515,
    shopingCartNumber: 0,
    vip: false
  }
};

colombia.version = {
  RFC: `${colombia.indicator}-${VERSIONS.colombia}`,
  date: ''
};

const venezuela: CountryConfig = {
  isPrimeActive: false,
  getService: true,
  getAvailability: true,
  selectAddressVnzla: true,
  disableScanAndGo: true,
  canActivateVenGuard: true,
  isExpress: false,
  activeHighDemand: true,
  mixedPayment: true,
  cartBilled: true,
  paymentMethodCity: true,
  getActiveCities: true,
  debounceTime: 0,
  updateAddress: false,
  cleanAddress: false,
  prefixPhone: 58,
  setContact: false,
  fbDataBase: 'https://oracle-services-vzla-delivery-tracking.firebaseio.com/',
  paymentMethods: [
    {id: '1', description: 'Mixto (Dólares en efectivo - Punto de venta)'},
    {id: '2', description: 'Punto de venta'},
    {id: '3', description: 'Transacciones en línea'},
    {id: '4', description: 'Pago en Tienda'},
    {id: '5', description: 'Seguros Bolivar'},
    {id: '6', description: 'Pago Movil'},
  ],
  pseUrlDatabase: '',
  pseStatus: false,
  deliveryTime: false,
  accountPush: false,
  deliveryTruck: false,
  deliveryAirplane: false,
  zendeskId: 360001066412,
  matrix: 0,
  redirectEnvialoYa: 'https://www.farmatodo.com.co/',
  envialoYa: false,
  addressId: 0,
  inviteSection: 'recomendaciones',
  home: {
    homeSections: [
      {
        componentType: 'BANNER',
        list: [
          {
            urlBanner:
              'https://lh3.googleusercontent.com/d4G22McK-iUo7tAO8IAFW7vT8POC41LszGl' +
              'hzimNPY4sDMBq3tgOnEdveAvmap60kiCDM7Ac2WuQq5o3gkebtbQYp3jaaaX9Mls',
            redirectURL: 'https://www.farmatodo.com.co/mundoOfertas',
            id: '1',
            firstDescription: 'default',
            orderingNumber: 1,
            mobile: false,
          },
          {
            urlBanner:
              'https://lh3.googleusercontent.com/6nxQJ7wCGyCQ9K51eWFmfpJlemzO8RNuBEpB87z0FYy' +
              'cTdBD7G-YcJ9VmThYiPkC24KPaqpTq7_XE9toTZDwtlqmW9RzY7W0lOjCuk0s3G-OBoR_Iw',
            redirectURL: 'https://www.farmatodo.com.co/mundoOfertas',
            id: '1',
            firstDescription: 'default',
            orderingNumber: 1,
            mobile: true,
          },
        ],
      },
      {
        componentType: 'HTML_LABEL',
        label: "<font color='#418fde'>Hola </font> Estas son las mejores ofertas",
      },
      {
        componentType: 'ITEM_LIST',
      },
      {
        componentType: 'THIN_BANNER',
        redirectURL: 'https://www.farmatodo.com.co/destacados/21643',
        urlBanner:
          'https://lh3.googleusercontent.com/EBR0D-3Zc7_GxHOb1QzA0oIB3Vb9PHfJIJu9' +
          'Jyzto2TN82tqji2HDD4x1JuQfxPYIOkcT--saOzFTpjBlbpS1xwj_NOCjzfZwXc',
      },
      {
        componentType: 'SQUARE_BANNER',
        list: [
          {
            urlBanner:
              'https://lh3.googleusercontent.com/ZwZE35dfEruJwI3LpoZekeHNc_-Oq57y4dazayQHzve' +
              'HSE2mCbsK23DXPa463YFXUA4Za_h0exQoAcUkteSzu_Pw_yXvz9Z9GiM',
            redirectURL: 'https://www.farmatodo.com.co/programate-y-ahorra/galeria',
          },
          {
            urlBanner:
              'https://lh3.googleusercontent.com/INtMGoW9LvCG1Ss7y7hbJJaZ' +
              'b4BndpA-q5gE5LEX35uAD7qoTkDLcSLEWRDkfxCwhyOFOJ8eLqjN7zb6pkv-PVSy3HeRJYsb1g',
            redirectURL: 'https://www.farmatodo.com.co/buscar?product=ensure',
          },
        ],
      },
      {
        componentType: 'THIN_BANNER',
        redirectURL: 'https://www.farmatodo.com.co/programate-y-ahorra/galeria',
        urlBanner:
          'https://lh3.googleusercontent.com/bCeCSgA_xsWGXlVrman2Oy_JnDTB5RrvB6ny' +
          'iVR1C0f83w78UL_-SlJtqZjiMMhJypaxz5_qNDw8GtxMq78axVXXnQpRgnD0LwA',
      },
      {
        componentType: 'HTML_LABEL',
        label: 'Destacados',
      },
    ],
    bannerFull: false,
    renderBottom: false,
    metaData: {
      title: 'Farmatodo Colombia - Droguería Online Domicilio las 24 Horas',
    },
  },
  buildDataCol: false,
  defCoordsLat: 10.4703965,
  defCoordsLng: -66.9625246,
  algolia: environment.algoliaVenezuela,
  backend: environment.backendVenezuela,
  firebaseConfig: firebaseVzlaConfig,
  firebaseEnv: firebaseVzlaEnv,
  generalEnv: generalVzlaEnv,
  countryCode: 58,
  ...profileConfigVzla,
  countryName: 'Venezuela',
  indicator: CountryEnum.VENEZUELA,
  isVenezuela: true,
  zendesk: zendeskConfigVen,
  currency: 'VEF',
  cctld: 've',
  routeImg: 'svg/ven-flag.svg',
  ssrTokens: ssrTokensVzla,
  version: {
    RFC: '',
    date: '',
  },
  analytics: {
    gtmContainer: 'GTM-W8V62KV',
    googleAdsConversionId: '',
  },
  defaultStoreId: 146,
  metaData: metaTagsVen,
  redes: redesVzla,
  allowIdStartsWithZero: true,
  defaultCity: 'CCS',
  freeDelivery: true,
  indexSeoHtml: 'items_seo_vzla',
  defaultNameCity: 'Caracas',
  braze: brazeConfigVzla.production,
  downloadApp: false,
  showAppBar: false,
  textSeoHome: {
    footer: ` <div class=" col-12 col-md-6">

     <h1 class="title-seo-h1">Farmacia online: Delivery</h1>
     <br><p class="description-page">¡Hola, bienvenido a Farmatodo! si aún no conoces nuestro portafolio, te contamos que tenemos todo lo que necesitas en un solo lugar:</p>
     <br><p class="description-page">Encontrarás desde productos de<strong> farmacia</strong>, ya que<strong> somos especialistas en medicamentos y todos los productos relacionados con el cuidado de salud</strong>, hasta todos productos de <a class= "text-seo-link" href="/categorias/alimentos-y-bebidas/alimentos?pag=2">despensa</a> como tortillas, <a class= "text-seo-link"href="/categorias/alimentos-y-bebidas/bebidas">gaseosas</a> y mucho más. Es decir, que puedes adquirir todo en un solo lugar y a un clic de distancia.</p>

   </div>
   <div class=" col-12 col-md-6">
     <h1 class="title-seo-h1">¿Cómo explorar nuestra página y categorías?</h1>
     <p  class="description-page">Lo primero que debes hacer es familiarizarte con ella. En la parte superior hallarás diversas pestañas, las cuales se componen por<a class= "text-seo-link"href="/categorias/salud-y-medicamentos"> salud y medicamentos</a>, <a class= "text-seo-link"href="/categorias/belleza"> belleza</a>,<a class= "text-seo-link"href="/categorias/bebe">cuidado del bebé</a>,<a class= "text-seo-link"href="/categorias/cuidado-personal"> cuidado personal</a>, <a class= "text-seo-link"href="/categorias/alimentos-y-bebidas"> alimentos y bebidas</a>, y todo lo relacionado con el <a class= "text-seo-link"href="/categorias/hogar-mascota-y-otros"> hogar, mascotas, diversión, entre otros</a>. De allí, se desplegará un universo de opciones para guiarte y llevarte a los productos que estás buscando. Además, podrás encontrar muchos más servicios destacados como nuestro<strong> delivery los 7 días de la semana</strong>, el <a class= "text-seo-link"href="/content/RevistaFarmatodo"> folleto de súper precios para todas las categorías</a>, <strong> envíaloYa, programa cuidamos tu salud, Asesoría farmacéutica en línea</strong> y muchos más.</p>
     <br><p  class="description-page">¡Déjate llevar y vive una experiencia única con farmatodo! </p>

   </div>`,
  },
  general: {
    legalCountryName: 'Venezuela C.A. RIF: J-00020200-1',
    offerText: 'recomendaciones',
    sag: {
      devices: {
        ios: false,
        android: false,
        browser: false,
      },
      urlSAG: 'https://oracle-services-vzla-scan-and-go.firebaseio.com/',
      disabledHome: true,
    },
    programAndSave: false,
    disableSas: true,
  },
  mobileAppUrl: 'https://farmatodo.onelink.me/1LxQ/fb8ba7b4',
  urlDirection: 'farmatodo.com.ve',
  urlDirectionIndcator: 'com.ve',
  ordersComponent: {
    loadMoreOrders: false,
  },
  producDetailComponent: {
    getAllServices: false,
    activateGtmObservable: false,
    imageList: true,
    deliveryTime: false,
    productPetal: true,
    storeAvailability: true,
    gtmValidate: true,
  },
  datafonoComponent: {
    fbDataBase: 'https://oracle-services-vzla-scan-and-go.firebaseio.com/',
  },
  algoliaSearchComponent: {
    getFIlterOption: {
      department: false,
    },
  },
  billingSummaryComponent: {
    firstOption: true,
    hiddenOption: false,
  },
  navbarFiltersCategoriesComponent: {
    orderBySelect: null,
    showFilters: false,
  },
  filtersComponent: {
    getQueryParam: 'AND Categoría',
  },
  footerComponent: {
    categories: {
      babyCareLink: 'bebe',
    },
    paymentMethods: {
      dataphone: 'Punto de venta',
    },
    otherLinks: {
      indexNav7: true,
      indexNav8: false,
      indexNav9: false,
      indexNav10: true,
      indexNav11: false,
      indexNav12: false,
      indexNav13: false,
    },
    showDownApp: false,
  },
  loginForm: {
    sendMessage: false,
    loadScript: false,
    validateHtml: true,
    placeholderEmail: 'Correo electrónico',
    FormControlValidate: true,
    valuesValidate: true,
    countryCodeValidate: false,
  },
  mapComponent: {
    defaultLocate: [5.2539193, -65.8267406],
    defaultLocateOpt: false,
    defaultZoom: 7,
    locateValid: true,
  },
  menuButtomComponent: {
    addItems: false,
    offerWorld: false,
  },
  deliveryTypeComponent: {
    national: false,
    envialoYa: false,
    envialoYaText: false,
  },
  cartComponent: {
    offerTextCart: 'recomendados',
    getSustitutes: false,
    noStok: false,
    validate: false,
    navigate: false,
    locationManager: false,
    inStock: false,
    quantitySummary: true,
  },
  categories: {
    tutorials: false,
    order: null,
  },
  guardActivate: false,
  storeGroupAlgolia: false,
  addressExpress: false,
  customerQuery: false,
  navbar: {
    tracking: 'tracking_vzla',
    modalAddressOne: false,
    modalAddressTwo: true,
    routerHome: false,
  },
  productCard: {
    petals: true,
    showPrice: true,
    cardClassCountry: 'card-ftd-vzla',
    priceIvaNoIva: true,
  },
  productDetailImg: {
    imageSmall: false,
    offerDescription: false,
  },
  productImg: {
    multiImage: true,
    getLabelText: false,
  },
  signUpForm: {
    zeroValidator: false,
  },
  currencySymbol: 'Bs.',
  metaTags: {
    title: 'Farmatodo: Farmacia Online las 24 Horas | Delivery',
    description:
      'Encuentra todo en medicamentos y productos de Farmacia, Cuidado Personal, Cuidado del Bebé, Belleza y Maquillaje, y todo en productos de hogar: alimentos, bebidas, mascotas y más en un solo lugar.',
  },
  creditCard: {
    validateTokenCvv: false,
  },
  singUpFormComponent: {
    phoneCodeOption: true,
    documentTypeOption: true,
    directSingUp: false,
    socialIcons: false,
    divider: false,
  },
  validatePhoneFormComponent: {
    validateWhitSms: false,
  },
  cancelOrderVM: {
    bdata: true,
  },
  customerAccountVM: {
    phoneCode: true,
  },
  account: {
    phoneCode: true,
    typeDocument: true,
    countryCode: false,
    cardHeight: true,
  },
  addEditAddress: {
    municipality: true,
    currentPosition: true,
    placeId: true,
  },
  bannersComponent: {
    bannerAvailable: true,
  },
  cartProductComponent: {
    available: true,
  },
  helpButton: {
    supportItem: true,
    hasSession: true,
    zopim: true,
  },
  phoneLength: 7,
  orderDetail: {
    paymentType1: 'Pago mixto',
    paymentType2: 'Punto de venta',
    objReOrderValidate: false,
    mapValidate: true,
  },
  addEditAddressCoponent: {
    objMapValidateLatLng: true,
    editDataPlaceId: true,
    notSearch: true,
    editPreviousAddress: true,
    editCityGroups: true,
    addressRequired: true,
    autocompleteEmptyLatLng: true,
    selectMunicipalityUndefined: true,
    selectAddressValidateCoordinates: true,
  },
  patchValue: true,
  setMarker: true,
  selectOptions: true,
  validateCoordinates: true,
  dataStatic: dataStaticAppVzla,
  p2c: true,
  bolivarDigital: true,
  christmas: false,
  vto: {
    domain: 'farmatodo.com.ve',
  },
  temporalStock: 20,
  amplitudeConfig: {
    platform: 'web',
    library: 'amplitude-js/8.21.4',
    version: '6.3.9',
    startVersion: '6.3.3',
    initialReferringDomain: 'www.farmatodo.com.ve',
    initialReferrer: 'https://www.farmatodo.com.ve/',
    language: 'Spanish',
  },
};
venezuela.version = {
  RFC: `${venezuela.indicator}-V3886C-1.0.6-Website`,
  date: '',
};

export const countries = [colombia, venezuela];

export { colombia as countryConfig };

export { venezuela as countryConfigVzla };
